import {AsgardFeatureNames, competitiveList, ICompretitiveFeature} from './AsgardFeatures';
import {BottomBarFeatures} from './BottomBarFeatures';

export interface AsgardFeature {
  name: AsgardFeatureNames | BottomBarFeatures;
  hidden: boolean;
  disabled: boolean;
  active: boolean;
  locked: boolean;
  competitiveActiveList: AsgardFeatureNames[] | BottomBarFeatures[];
  competitiveUnActiveList: AsgardFeatureNames[] | BottomBarFeatures[];
}

export class CurrentUIState {

  constructor(features: object) {
    this.init(features);
  }

  init(features: object): void {
    for (const featureName of Object.keys(features)) {
      if (features.hasOwnProperty(featureName)) {
        this[featureName] = {
          name: featureName as AsgardFeatureNames | BottomBarFeatures,
          hidden: false,
          disabled: false,
          locked: false,
          active: false,
          competitiveActiveList: this.findCompetitiveActiveFeatureList(featureName as AsgardFeatureNames | BottomBarFeatures),
          competitiveUnActiveList: this.findCompetitiveUnActiveFeatureList(featureName as AsgardFeatureNames | BottomBarFeatures)
        };
      }
      if (featureName === AsgardFeatureNames.PRINT) {
        this[featureName].disabled = true;
      }
    }
  }

  disableFeature(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].disabled = true;
  }

  enableFeature(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].disabled = false;
  }

  lockFeature(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].locked = true;
  }

  unlockFeature(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].locked = false;
  }

  hideFeautre(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].hidden = true;
  }

  showFeautre(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].hidden = false;
  }

  setFeatureActive(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].active = true;
    if (this[featureName].competitiveActiveList.length) {
      this.setListOfFeaturesUnActive(this[featureName].competitiveActiveList);
    }
  }

  setFeatureUnActive(featureName: AsgardFeatureNames | BottomBarFeatures): void {
    this[featureName].active = false; // this doesn't work? TODO: reevaluate
    if (this[featureName].competitiveUnActiveList.length) {
      this.setListOfFeaturesUnActive(this[featureName].competitiveUnActiveList);
    }
  }

  setListOfFeatruesHidden(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.hideFeautre(featureName);
    });
  }

  setListOfFeatruesShow(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.showFeautre(featureName);
    });
  }

  setListOfFeaturesDisabled(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.disableFeature(featureName);
    });
  }

  setListOfFeaturesActive(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.setFeatureActive(featureName);
    });
  }

  setListOfFeaturesUnActive(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.setFeatureUnActive(featureName);
    });
  }

  setListOfFeaturesLocked(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.lockFeature(featureName);
    });
  }

  setListOfFeaturesUnlocked(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.unlockFeature(featureName);
    });
  }

  enableListOfFeatures(featureNames: AsgardFeatureNames[] | BottomBarFeatures[]): void {
    featureNames.forEach((featureName) => {
      this.enableFeature(featureName);
    });
  }

  disableAllFeatures(): void {
    for (const key in this) {
      if (this[key] && (this[key] as unknown as AsgardFeature).name) {
        (this[key] as unknown as AsgardFeature).disabled = true;
      }
    }
  }

  enableAllFeatures(): void {
    for (const key in this) {
      if (this[key] && (this[key] as unknown as AsgardFeature).name) {
        (this[key] as unknown as AsgardFeature).disabled = false;
      }
    }
  }

  private findCompetitiveActiveFeatureList(e: AsgardFeatureNames | BottomBarFeatures): AsgardFeatureNames[] | BottomBarFeatures[] | []  {
    const list = competitiveList.find((i: ICompretitiveFeature) => i.feature === e);
    if (!list || list && !list.competitiveActiveList) {
      return [];
    }
    return list.competitiveActiveList;
  }

  private findCompetitiveUnActiveFeatureList(e: AsgardFeatureNames | BottomBarFeatures): AsgardFeatureNames[] | BottomBarFeatures[] | [] {
    const list = competitiveList.find((i: ICompretitiveFeature) => i.feature === e);
    if (!list || list && !list.competitiveUnActiveList) {
      return [];
    }
    return list.competitiveUnActiveList;
  }

}


export const uiState = new CurrentUIState(AsgardFeatureNames);
